import { UserRole } from "../../types/common/permissions";
import { ModeratorPermission } from "../../types/api/moderators";

type PermissionConfig = {
  roles: UserRole[];
  permissions: ModeratorPermission[];
};

const all = [UserRole.SUPERADMIN, UserRole.ADMIN, UserRole.MODERATOR];
const onlyAdmin = [UserRole.SUPERADMIN, UserRole.ADMIN];

export const PERMISSIONS_CONFIG = {
  // Пользователи
  VIEW_USERS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_VIEW_USERS],
  },

  VIEW_USER: {
    roles: all,
    permissions: [ModeratorPermission.CAN_VIEW_USERS],
  },

  VIEW_USER_ADS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_VIEW_ADS],
  },

  VIEW_USER_APPEALS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_VIEW_APPEALS],
  },

  VIEW_USER_SUGGESTIONS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_VIEW_PROPOSALS],
  },

  VIEW_USER_COMPLAINTS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_VIEW_COMPLAINTS],
  },

  // Объявления
  VIEW_ADS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_VIEW_ADS],
  },

  VIEW_AD: {
    roles: all,
    permissions: [ModeratorPermission.CAN_VIEW_ADS],
  },

  VIEW_ADS_FAQ: {
    roles: all,
    permissions: [ModeratorPermission.CAN_VIEW_ADS],
  },

  // Форумы
  VIEW_FORUMS: {
    roles: all,
    permissions: [],
  },

  VIEW_FORUM: {
    roles: all,
    permissions: [],
  },

  VIEW_FORUM_COMMENTS: {
    roles: all,
    permissions: [],
  },

  // Система
  VIEW_NOTIFICATIONS: {
    roles: onlyAdmin,
    permissions: [],
  },

  VIEW_HELP: {
    roles: all,
    permissions: [],
  },

  VIEW_LOGS: {
    roles: onlyAdmin,
    permissions: [],
  },

  VIEW_METRICS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_VIEW_DASHBOARD_METRICS],
  },

  // Администрирование
  VIEW_MODERATORS: {
    roles: onlyAdmin,
    permissions: [],
  },

  VIEW_SECTIONS: {
    roles: onlyAdmin,
    permissions: [],
  },

  VIEW_CATALOGS: {
    roles: onlyAdmin,
    permissions: [],
  },
  BLOCK_USERS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_BLOCK_USERS],
  },
  BLOCK_ADS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_BLOCK_ADS],
  },
  APPROVE_ADS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_APPROVE_ADS],
  },
  REPLY_APPEALS: {
    roles: all,
    permissions: [ModeratorPermission.CAN_REPLY_APPEALS],
  },
} as const satisfies Record<string, PermissionConfig>;
